// extracted by mini-css-extract-plugin
module.exports = {"heading":"discovery-list-unit_heading__tSFmb","grid":"discovery-list-unit_grid__lTc5d","pager-button":"discovery-list-unit_pager-button__xZJFd"};